<template>
  <tr>
    <td>
      {{ occupation.title }}
      <template v-if = 'occupation.tags.green'>
        <img
          src = '../assets/images/green_job.png'
          v-tooltip.top-center = '{ content: "<span>Green</span> Occupation", offset: 5, classes: "green-tooltip" }'
          height = '14'
        >
      </template>
      <template v-if = 'occupation.tags.bright_outlook'>
        <img
          src = '../assets/images/bright_outlook_job.png'
          v-tooltip.top-center = '{ content: "<span>Bright</span> Outlook", offset: 5, classes: "bright-outlook-tooltip" }'
          height = '14'
        >
      </template>
    </td>
    <td>{{ dollars(occupation.salary.annual_median) }}</td>
    <td class = 'salary-cell'>
      <div class = 'salary-occupation'>
        <div class = 'salary-labels'>
          <div
            class = 'salary-label salary-min'
            :style = '{left: getSalaryOffset(salary10th)}'
          >
            {{ dollars2(salary10th) }}
          </div>
          <div
            class = 'salary-label salary-median'
            :style = '{left: getSalaryOffset(salaryMedian)}'
          >
            {{ dollars2(salaryMedian) }}
          </div>
          <div
            class = 'salary-label salary-max'
            :style = '{left: getSalaryOffset(salary90th)}'
          >
            {{ dollars2(salary90th) }}
          </div>
        </div>
        <div class = 'salary-markers'>
          <div
            class = 'salary-domain salary-marker-outer ds-border ds-main'
            :style = 'rangeStyles'
          ></div>
          <div
            class = 'salary-marker salary-marker-outer ds-border ds-main'
            v-tooltip.top-center = '{ content: "Annual 10th Percentile", offset: 5 }'
            :style = '{left: getSalaryOffset(salary10th)}'
          ></div>
          <div
            class = 'salary-marker ds-border ds-main'
            v-tooltip.top-center = '{ content: "Annual Median", offset: 5 }'
            :style = '{left: getSalaryOffset(salaryMedian)}'
          ></div>
          <div
            class = 'salary-marker salary-marker-outer ds-border ds-main'
            v-tooltip.top-center = '{ content: "Annual 90th Percentile", offset: 5 }'
            :style = '{left: getSalaryOffset(salary90th)}'
          ></div>
        </div>
      </div>
    </td>
  </tr>
</template>

<script>
  import {format} from 'd3'

  export default {
    props: {
      occupation: {
        type: Object,
        required: true
      },

      salaryMin: {
        type: Number,
        required: true
      },

      salaryRange: {
        type: Number,
        required: true
      }
    },

    data() {
      return {
        dollars: format('$,'),
        dollars2: format('$.2s')
      }
    },

    computed: {
      salary10th() {
        return this.occupation.salary.annual_10th_percentile
      },

      salaryMedian() {
        return this.occupation.salary.annual_median
      },

      salary90th() {
        return this.occupation.salary.annual_90th_percentile || this.occupation.salary.annual_90th_percentile_over
      },

      rangeStyles() {
        return {
          left: this.getSalaryOffset(this.salary10th),
          width: 100 * (this.salary90th - this.salary10th) / this.salaryRange + '%'
        }
      }
    },

    methods: {
      getSalaryOffset(salary) {
        return (100 * (salary - this.salaryMin) / this.salaryRange) + '%'
      }
    }
  }
</script>



// WEBPACK FOOTER //
// occupation.vue?5523513c